import React from 'react';

export function Me() {
  return <span className="team-members__me"> (me)</span>;
}
